import {
  IconBookmark,
  IconBuildings,
  IconCoil,
  IconEnergyCircle,
  IconInfo,
  IconMeter,
  IconPencil,
  IconPenSquare,
  IconPlug,
  IconPower,
  IconRuler,
  IconSearch,
  IconShare,
  IconShareGray,
  IconSignal,
  IconTools,
  IconUpload,
} from '@assets/images/icon';
import { IconAnalyze, IconTopology, schemeAoa, schemeBle, schemeComfort, schemeUwb } from '@assets/images/main';
import { accessAuto1, accessAutoMain, accessPro1, accessProMain, accesscontroller1, accesscontrollerMain } from '@assets/images/main/access/product';
import { vehicleTrackingKit1, vehicleTrackingKit5, yardTrackingKit1, yardTrackingKit4 } from '@assets/images/main/outdoor';

export default {
  a: [
    { text: '技術方式', icon: IconInfo },
    { text: '位置精度', icon: IconSignal },
    { text: '送信周期', icon: IconUpload },
    { text: '連携構造', icon: IconTopology },
    { text: '電源入力', icon: IconPlug },
    { text: '推奨環境', icon: IconBookmark },
    { text: '特長', icon: IconPencil },
    { text: '外部連携', icon: IconShare },
  ],

  b: [
    { text: 'GNSSベースのGPS測位' },
    { text: '±3メートル' },
    { text: '最大1分あたり30回' },
    { text: 'GPSデバイス（LTE） → ORBROサーバー' },
    { text: 'USB-C' },
    { text: '車両追跡、資産追跡' },
    { text: '1台の端末で位置情報を取得可能' },
    { text: 'API提供' },
  ],

  c: [
    { text: 'LoRAベースのGPS信号受信' },
    { text: '±3メートル' },
    { text: '最大1分あたり120回' },
    { text: 'GPSタグ → LoRA受信機 → ORBROサーバー' },
    { text: 'PoE' },
    { text: 'ヤード、港湾、物流センター、建設現場など' },
    { text: '特定エリア内で複数タグの信号を受信、<br/>通信費不要で利用可能' },
    { text: 'API提供（リアルタイムイベント／位置／状態の連携）' },
  ],

  spec: [
    {},

    {
      image: vehicleTrackingKit5,
      link: '/outdoor/gps',
      title: 'GPSデバイス',
      desc: '',
    },

    {
      image: yardTrackingKit4,
      link: '/outdoor/lora',
      title: 'GPSタグ（LoRA）',
      desc: '',
    },
  ],
};
